import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import {AppSettings} from '../../app-settings';
import {SessionService} from '../../Services/session.service';
import { ActivatedRoute } from '@angular/router';
import {HttpClientService} from '../../Services/http-client.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-activity-forums-sidebar',
  templateUrl: './activity-forums-sidebar.component.html',
  styleUrls: ['./activity-forums-sidebar.component.css']
})
export class ActivityForumsSidebarComponent implements OnInit {

	tabPro:String = "tabPro";
	tabSec:String = "tabSec";
	tabActive:String ="tabPro";
	isSideBarOpen: Boolean = false;
	yesVisible:Boolean = false;
	noVisible: Boolean = false;
	showForums:boolean = true;
    mobileDots = AppSettings.cdnUrl + "assets/images/3-mobile-dots.png";
	bulletImage = AppSettings.cdnUrl + "assets/images/bullet.png";
	closeImage =  AppSettings.cdnUrl + "assets/images/f_side_close_high.png";
	activityId:number;
	pageName:string;
	activityType:string;
	corelationID:string;
	forumMode:string = "ACTIVITY";
	SideBarText:string = "Do you have a question?";
	YesFirstLine:string = "Review current Forum queries";
	YesSecondLine:string = "Post your doubt (If not already answered)";
	YesThirdLine:string = "Get a response within 1 business day!";
	NoFirstLine:string = "Go to the relevant slide";
	NoSecondLine:string = "Post your doubt (If not already answered)";
	NoThirdLine:string = "Get a response within 1 business day!";
  accessedForumsFlag:boolean=false;

	@ViewChild('_forumSideBar', { static: false }) forumSideBar: ElementRef;

  constructor(private sessionService: SessionService, private route: ActivatedRoute,private httpClientService: HttpClientService) { }

  ngOnInit() {

  		this.getForumsMode();
  		this.sessionService.closeForumsSidebar$
     .subscribe(item => { if(item != 0) { this.isSideBarOpen = false}}
   );
  }
  getForumsMode()
  {
  	this.route.params.subscribe(params => {
  		if(params['activity'])
        {
        	this.activityId = params['activity'];
        	this.pageName = params['page'];
        	//this.getForumSideBar();

        	//uncomment the following for Slide Forums

        	/*let headers = new HttpHeaders();
        	this.httpClientService.get(AppSettings.restApiUrl +
        	'/api/activity/'+this.activityId+'/forum/0/', headers)
        	.subscribe(
        	(data) => {
        	    this.forumMode = data.forumType;
        	    if(this.forumMode == "SLIDE")
        	    {
        	    	this.SideBarText = "Do you have a question on this slide?";
        	    	this.sessionService.updateDashboard(1);
        	    }
        	});*/
        }
        else if(params['corelationid'])
        {
        	this.showForums = true;
        	this.corelationID = params['corelationid'];

        	//uncomment the following for Slide Forums

        	/*let headers = new HttpHeaders();
    		this.httpClientService.get(AppSettings.restApiUrl + '/api/link/forum/' + this.corelationID + '/', headers)
      		.subscribe(
      		(data) => {

      			this.forumMode = data.forumType;
      			if(this.forumMode == "SLIDE")
        	    {
        	    	this.SideBarText = "Do you have a question on this slide?";
        	    }

      		});*/
        }
        this.tabActive ="tabPro";
    });
  }

  getForumSideBar()
  {
  	/*let headers = new HttpHeaders();
    this.httpClientService.get(AppSettings.restApiUrl + '/api/activity/' + this.activityId + '/page/' + this.pageName+"/", headers)
      .subscribe(
      (data) => {

        this.activityType = data.activityType;
        if(this.activityType == "MIQA")
        {
        	this.showForums = false;
        }
        else
        {
        	this.showForums = true;
        }
      }

      );*/
  }
	sideBarOpen()
	{
		this.isSideBarOpen=true;
		this.sessionService.updateActivityState(1);
		this.sessionService.closeActivitySidebar(1);
	}
	toggle(tabName:String, vevent)
	{

	  	this.tabActive = tabName;
	}
	showFormus()
	{
    this.accessedForumsFlag=true;
    this.sessionService.shareAccessedForumsState(this.accessedForumsFlag);
		if(this.forumMode == "SLIDE")
		{
			this.showSlideForums();
		}
		else
		{
			this.showActivityForums();
		}

	}
	showActivityForums()
	{
		this.sessionService.updateActivityForumsDisplayState(1);
	}
	showSlideForums()
	{
		// Commnet below three lines for slide forums
		this.sessionService.updateDashboard(1);
		this.sessionService.updateActivityState(1);
		this.closeAllElements();
		// Uncommnet below line for slide forums
		//this.sessionService.updateActivityForumsDisplayState(1);
	}
	closeAllElements()
	{
		this.isSideBarOpen=false;
		this.yesVisible=false;
		this.noVisible=false;
		this.sessionService.updateActivityState(0);
		//this.disableActiveCkEditor();
		(<HTMLElement>document.activeElement).blur();
	}
	closeOtherSideBar(event)
	{
		/*var el  = event.target;
		var closeSidebar = false;
		while ((el = el.parentElement))
		{
			if(el == this.forumSideBar.nativeElement)
			{
				return;
			}
		};
		this.closeAllElements();*/
	}
	loadNotes()
	{
		this.sessionService.showActivityNotes(1);
	}
}
